module.exports = __webpack_public_path__ + "assets/img/t4.cefd484f.png";